import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CHAT_FEATURE_KEY,
  State,
  chatAdapter,
  ChatEntity
} from './chat.reducer';

// Lookup the 'Chat' feature state managed by NgRx
export const getChatState = createFeatureSelector<State>(CHAT_FEATURE_KEY);

const { selectEntities } = chatAdapter.getSelectors();

export const getActiveId = createSelector(
  getChatState,
  (state: State) => state.selectedId
)

export const getActiveChatCount = createSelector(
  getChatState,
  (state: State) => state.selectedChatCount
)

export const getChatEntities = createSelector(
  getChatState,
  (state: State) => selectEntities(state)
)

export const getActiveChat = createSelector(
  getActiveId,
  getChatEntities,
  (id, entities) => (id ? entities[id] as ChatEntity : null)
)

export const getInitialized = createSelector(
  getChatState,
  (state: State) => state.isInitialized
);

export const getChatLoading = createSelector(
  getChatState,
  (state: State) => state.loading
);

export const getAuth = createSelector(
  getChatState,
  (state: State) => state.auth
)

export const getConnectionState = createSelector(
  getChatState,
  (state: State) => state.connectionState
)

export const getIdentity = createSelector(
  getChatState,
  (state: State) => state.identity
)

export const getMessages = createSelector(
  getActiveChat,
  (chat => chat?.messages)
)

export const getParticipants = createSelector(
  getActiveChat,
  (chat => chat?.participants)
)


export const isSidebarOpen = createSelector(
  getChatState,
  (chat => chat.isSidebarOpen)
)

export const getMode = createSelector(
  getChatState,
  (chat => chat.mode)
)
export const activeCustomer = createSelector(
  getChatState,
  (chat => chat.activeCustomer)
)

export const getSessionId = createSelector(
  getChatState,
  (chat => chat.sessionId)
)

